import { HttpError, RQAPICallWithData } from 'store/APIClient';
import { UseQueryResult, useQuery } from '@tanstack/react-query';

import { IndicatorBaseT } from 'business/definitions';
import { useDispatch } from 'store/hooks';
import { useTranslation } from 'react-i18next';
import { useEffect } from 'react';

export type RootChartT = IndicatorBaseT;

const getRootChart = async (url: string): Promise<RootChartT> => {
    const response = await RQAPICallWithData<RootChartT>({
        endpoint: 'support/chart_templates/root_chart',
        body: { root_url: url },
        method: 'POST',
    });
    return response.content.data;
};

export const useGetRootChart = (
    url: string,
): Pick<UseQueryResult<RootChartT, HttpError>, 'refetch' | 'data'> => {
    const { t } = useTranslation();
    const dispatch = useDispatch();

    const { refetch, data } = useQuery<RootChartT, HttpError>({
        queryKey: ['chart-template-root-chart', url],
        queryFn: async () => getRootChart(url),
        enabled: false,

        meta: {
            useGlobalOnError: true,
        },
    });

    useEffect(() => {
        if (data) {
            dispatch.vision.notifyUser({
                message: t(
                    'support.chartsTemplates.createOrEditModal.chartUrlInput.updatedUrl',
                ),
                snackType: 'success',
            });
        }
    }, [data]);

    return { refetch, data };
};
